import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

import { ResetPage } from './pages/reset/page';
import { NotFoundPage } from './pages/notfound';
import { OnboardingPage } from './pages/onboarding';
import { LanguageSettings } from './components/language-settings';

async function forceRemoveServiceWorkers() {
	try {
		const registrations = await navigator.serviceWorker.getRegistrations();
		
		for (const registration of registrations) {
			registration.unregister();
		}
	}
	catch {}
}
forceRemoveServiceWorkers();

ReactDOM.render(
  <LanguageSettings>
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={ResetPage} />
        <Route path="/onboarding" component={OnboardingPage} />
        <Route component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  </LanguageSettings>,
  document.getElementById("root")
);